import React from 'react'
import Tittle from '../Components/Tittle';
import { useForm } from 'react-hook-form';
import 'react-toastify/dist/ReactToastify.min.css';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import '../styles/contactPage.css'

function ContactPage() {
    const { register, handleSubmit, reset, formState:{ errors } } = useForm();
    console.log(process.env.REACT_APP_SERVICE_ID)
    const toastifySuccess = () => {
        toast('Form sent!', {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          className: 'submit-feedback success',
          toastId: 'notifyToast'
        });
      };

      const onSubmit = async (data) => {
        // Send form email
        try {
          const templateParams = {
            name: data.name,
            email: data.email,
            subject: data.subject,
            message: data.message
          };
    
          await emailjs.send(
            // process.env.REACT_APP_SERVICE_ID,
            // process.env.REACT_APP_TEMPLATE_ID,
            // templateParams,
            // process.env.REACT_APP_USER_ID
           "service_iaxterh","template_3na1q8o",templateParams,"user_UFQJ1NtJTKH8tGNzGZOKC"
          );
          
    
          reset();
          toastifySuccess();
        } catch (e) {
          console.log(e);
        }
      };
    return (
        <div className="contact-hight" >
            <div className="title">
                <Tittle title={'About Me'} span={'About Me'} />
            </div>
            <div className='ContactForm'>
      <div className='main-content'>
            <div className='contactForm'>
              <form id='contact-form' onSubmit={handleSubmit(onSubmit)} noValidate>
                {/* Row 1 of form */}
                <div className='formRow'>
                    <input
                      type='text'
                      name='name'
                      {...register("name",{
                        required: { value: true, message: 'Please enter your name' },
                        maxLength: {
                          value: 30,
                          message: 'Please use 30 characters or less'
                        }
                      })}
                      className='form-control formInput'
                      placeholder='Name'
                    ></input>
                    {errors.name && <span className='errorMessage'>{errors.name.message}</span>}
                  
                    <input
                      type='email'
                      name='email'
                      {...register("email",{
                        required: true,
                        pattern: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                      })}
                      className='form-control formInput'
                      placeholder='Email address'
                    ></input>
                    {errors.email && (
                      <span className='errorMessage'>Please enter a valid email address</span>
                    )}
                
                </div>
                {/* Row 2 of form */}
                <div className='formRow'>
                    <input
                      type='text'
                      name='subject'
                      {...register("subject",{
                        required: { value: true, message: 'Please enter a subject' },
                        maxLength: {
                          value: 75,
                          message: 'Subject cannot exceed 75 characters'
                        }
                      })}
                      className='form-control formInput'
                      placeholder='Subject'
                    ></input>
                    {errors.subject && (
                      <span className='errorMessage'>{errors.subject.message}</span>
                    )}
                
                </div>
                {/* Row 3 of form */}
                <div className='formRow'>
                    <textarea
                      rows={3}
                      name='message'
                      {...register("message",{
                        required: true
                      })}
                      className='form-control formInput'
                      placeholder='Message'
                    ></textarea>
                    {errors.message && <span className='errorMessage'>Please enter a message</span>}
                </div>
                <button className='submit-btn' type='submit'>
                  Submit
                </button>
              </form>
            </div>
            <ToastContainer />
        
      </div>
    </div>

        </div>
    )
}

export default ContactPage;
